import { render, staticRenderFns } from "./royaltySettingAll.vue?vue&type=template&id=422b429e"
import script from "./royaltySettingAll.vue?vue&type=script&lang=js"
export * from "./royaltySettingAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports